import React from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Contact } from '../../../../shared/constants/contact';

import toastSuccess from '../../../../assets/icons/toast-success.svg';
import toastError from '../../../../assets/icons/toast-error.svg';
import Close from '../../../../assets/icons/General/close.svg?react';

const ReportSuccessToast = () => {
  const { t } = useTranslation();
  return (
    <div className="border-greene-300 bg-greene-25 m-2 rounded-xl border shadow-[0px_1px_2px_0px_#1018280D] lg:m-0">
      <div className="mb-2 flex justify-between pr-[21px]">
        <img src={toastSuccess} className="p-[7px]" alt="" />
        <button className="text-sm font-medium">
          <Close
            stroke="var(--color-black-500)"
            onClick={() => toast.dismiss('reportGenerated')}
            className="w-[10px]"
          />
        </button>
      </div>
      <div className="px-4 pb-4 text-left">
        <h5 className="text-black-900 text-sm font-semibold">
          {t('REPORT_SUCCESS_TOAST_HEADING')}
        </h5>
        <p className="text-black-600 text-sm">
          {t('REPORT_SUCCESS_TOAST_SUBHEADING')}
        </p>
      </div>
    </div>
  );
};

const ReportFailToast = () => {
  const { t } = useTranslation();
  return (
    <div className="border-redd-300 bg-redd-25 m-2 rounded-xl border shadow-[0px_1px_2px_0px_#1018280D] lg:m-0">
      <div className="mb-2 flex justify-between pr-[21px]">
        <img src={toastError} className="p-[7px]" alt="" />
        <button className="text-sm font-medium">
          <Close
            stroke="var(--color-black-500)"
            onClick={() => toast.dismiss('reportFailed')}
            className="w-[10px]"
          />
        </button>
      </div>
      <div className="px-4 pb-4 text-left">
        <h5 className="text-black-900 text-sm font-semibold">
          {t('REPORT_FAIL_HEADING')}
        </h5>
        <p className="text-black-600 mb-3 text-sm">
          {t('REPORT_FAIL_SUBHEADING')}
        </p>
        <p className="text-black-600 text-sm">
          <label>Contact us at </label>
          <a
            href={`mailto:${Contact.Email}`}
            className="text-primary-600 text-sm font-semibold"
          >
            {Contact.Email}
          </a>
        </p>
      </div>
    </div>
  );
};

export const handleGeneratedHide = () => {
  toast(<ReportSuccessToast />, {
    toastId: 'reportGenerated',
  });
};

export const handleFailHide = () => {
  toast(<ReportFailToast />, {
    toastId: 'reportFailed',
  });
};
